<template>
	<div>
		<ul class="mb-200-md mb-100-smo">
			<li
				v-for="(item, i) in list"
				:key="i"
				:class="[
					{
						'mt-200': i !== 0,
						'bb border-color-reversed': i !== list.length - 1
					}
				]"
			>
				<h3 class="heading-1 position-relative font-weight-lighter text-color-white">
					{{ item.heading }}<sup class="position-absolute tm zeta">TM</sup>
				</h3>
				<p
					:class="[
						'text-color-gray-40 mt-50',
						{
							'mb-200': i !== list.length - 1
						}
					]"
					>{{ item.description }}</p
				>
			</li>
		</ul>
	</div>
</template>
<script setup lang="ts">
const list: Array<{ heading: string; description: string }> = [
	{
		heading: 'Basis',
		description: 'An operating system for real estate asset management'
	},
	{
		heading: 'Cornice',
		description: 'An operating system for investor servicing and fund management'
	},
	{
		heading: 'Equitize',
		description:
			'A fintech platform to provide more flexible equity funding for the best technology companies and the teams who build them.'
	}
];
</script>
<style lang="scss" scoped>
.tm {
	top: 23px;
}
</style>
